module.exports = __webpack_public_path__ + "static/media/da.8cc783cf.svg";